module.exports = __webpack_public_path__ + "static/media/6_4.154cf8e2.png";